import { createSelector } from 'reselect'
import { selectTask } from '@store/slices/task.slice'

export const selectTasksLoading = createSelector(
  [selectTask],
  (tasks) => tasks.loading
)
export const selectRunningTaskIds = createSelector(
  [selectTask],
  (tasks) => tasks.runningTaskIds
)
export const selectUnresolvedTaskIds = createSelector(
  [selectTask],
  (tasks) => tasks.unresolvedTaskIds
)
